export enum RouteType {
  OPTIMIZED = "optimized",
  ORDERED = "ordered",
}
